import React from "react";
import { observer } from "mobx-react";
import SearchForm from "@search/SearchForm";
import Searchbar from "@search/Searchbar";
import { renderFrom, renderTo, renderUsers } from "@search/filters";
import { SharedFileFilterManager } from "./SharedFileFilterManager";
import { useLocale } from "@hooks";
import { useGetUserSelectUsersQuery } from "@graphql";

type Props = {
  manager: SharedFileFilterManager;
};

export const SharedFileSearchForm: React.FC<Props> = (props) => {
  const { manager } = props;
  const { locale } = useLocale();

  const { data: usersData } = useGetUserSelectUsersQuery();

  const searchbar = (
    <Searchbar
      onChange={(v) => manager.updateFilter({ text: v })}
      value={manager.filter.text}
    />
  );

  const ba = renderUsers(
    usersData?.users ?? [],
    locale.User,
    manager.filter.userIds,
    (v) => manager.updateFilter({ userIds: v }),
    manager.isFilterDirty("userIds")
  );

  const from = renderFrom(
    manager.filter.from,
    (v) => manager.updateFilter({ from: v }),
    manager.isFilterDirty("from"),
    manager.filter.to
  );

  const to = renderTo(
    manager.filter.to,
    (v) => manager.updateFilter({ to: v }),
    manager.isFilterDirty("to"),
    manager.filter.to
  );

  return (
    <SearchForm searchbar={searchbar}>
      <>
        {ba} {from} {to}
      </>
    </SearchForm>
  );
};

export default observer(SharedFileSearchForm);
